module.exports = __webpack_public_path__ + "static/media/HCMM326.5c7ab4d6.jpg";